import axios from "axios";

export default axios.create({
  baseURL: process.env.VUE_APP_FITMO_BACKEND_URL,
  headers: {
    "Content-Type": "application/json",
  },
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  withXSRFToken: true,
  withCredentials: true,
});
